var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlash = function SvgSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 1.988c5.53 0 10.012 4.483 10.012 10.012S17.529 22.012 12 22.012 1.99 17.529 1.988 12C1.988 6.47 6.471 1.989 12 1.988m-6.64 4.22A8.78 8.78 0 0 0 3.189 12 8.813 8.813 0 0 0 12 20.811c2.217 0 4.24-.821 5.79-2.172zM12 3.188c-2.217 0-4.243.82-5.792 2.172l12.43 12.43A8.77 8.77 0 0 0 20.812 12 8.81 8.81 0 0 0 12 3.188"
  })));
};
export default SvgSlash;